import { capitalize } from "lodash";
import React, {useMemo, useReducer, useRef} from "react";
import SimpleReactValidator from "simple-react-validator";

export const useSimpleReactValidator = (options = {}) => {
  /**
   * Workaround to get SimpleReactValidator work in functional components
   * https://github.com/dockwa/simple-react-validator/issues/97#issue-453435212
   */
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  return useRef(new SimpleReactValidator({
    autoForceUpdate: { forceUpdate },
    messages: { default: ":attribute is required" },
    element: (message) => <span className="text-danger plan-main-txt">{capitalize(message || "")}</span>,
    ...options
  }));
};
